module.exports = __webpack_public_path__ + "static/media/media.b80ea62a.svg";